import { EProfessionalApprovalStatus } from "@/domain/enums/EProfessionalApprovalStatus";
import { StatusBadgeViewModel } from "../viewmodels/StatusBadgeViewModel";

// Badge de status de aprovação — compartilhado entre toViewModel (detalhe
// do profissional) e toEligibleViewModel (lista de profissionais
// elegíveis), ambos em ProfessionalPresentationMappers.
const buildApprovalStatusBadge = (approved: EProfessionalApprovalStatus): StatusBadgeViewModel => {
    if (approved === EProfessionalApprovalStatus.APPROVED) {
        return { title: "Aprovado", color: "text-success", bg: "bg-success-soft" }
    }
    if (approved === EProfessionalApprovalStatus.REJECTED) {
        return { title: "Reprovado", color: "text-danger", bg: "bg-danger-soft" }
    }
    return { title: "Pendente de análise", color: "text-warning", bg: "bg-warning-soft" }
}

export default buildApprovalStatusBadge
